/* Core & libraries */
import React, {useEffect, useState} from "react";
import {useTheme} from "react-jss";
import {FormattedMessage} from "react-intl";

/* Helpers, constants, custom methods, internal libraries */


/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import {ReactComponent as StarSvg} from '../../../resources/images/star.svg';
import {ReactComponent as RepeatIcon} from "resources/images/repeat-icon.svg";

/* Styles */
import styles from "./styles";
import UCButton from "components/buttons";

const ResubmitRedemptionModal = ({row, getLoyaltyList, addRedemption, updateRedemptionsList}) => {
  const theme = useTheme();
  const classes = styles({theme});

  const [showResubmitRedemptionModal, setShowResubmitRedemptionModal] = useState(false)

  const handleSaveModal = () => {
    setShowResubmitRedemptionModal(false)
  }

  return (<>
      <UCButton
        className={classes.resubmitRedemptionButton}
        type="transparent"
        text=""
        icon={<RepeatIcon/>}
        onClick={() => setShowResubmitRedemptionModal(true)}
      />
      <UCModal
        className={classes.resubmitRedeptionModal}
        showModal={showResubmitRedemptionModal}
        setShowModal={setShowResubmitRedemptionModal}
        modalIcon={<StarSvg/>}
        modalTitle={<FormattedMessage id="resubmitRedeptionModal.title"/>}
        modalDescription={<FormattedMessage id="resubmitRedeptionModal.description"/>}
        modalContent={
          <Content
            setShowModal={setShowResubmitRedemptionModal}
            handleSaveModal={handleSaveModal}
            row={row}
            getLoyaltyList={getLoyaltyList}
            updateRedemptionsList={updateRedemptionsList}
            addRedemption={addRedemption}
          />
      }
      />
    </>

  )
}

export default ResubmitRedemptionModal;
